export const apiEn = {
  datatable: {
    rowsperpage: 'Rows per page:'
  }
};
